import { useState, useEffect } from "react";

import * as APIModels from "../../../models";
import { QueueService } from "../../../services/SubmissionService";
import { DataService } from "../../../services/DataService";
import QueueRow from "./QueueRow";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import Select, { ActionMeta } from "react-select";
import moment from "moment";

type OptionType = { label: string; value: string };
export interface SnackBarState extends SnackbarOrigin {
    open: boolean;
    message: string;
}

export default function FileQueue({
    filter,
    state,
}: {
    filter?: string;
    state?: string;
}) {
    const q: APIModels.AttorneyQueue[] = [];
    const [queuelist, setQueueList] = useState(q);
    const [error, setError] = useState("");

    const [stateId, setStateId] = useState(state);
    const [stateOptions, setStateOptions] = useState([] as OptionType[]);
    const [snackbar, setSnackbar] = useState<SnackBarState>({
        open: false,
        message: "",
        vertical: "top",
        horizontal: "right",
    });

    const showSnackbar = (message: string) => {
        setSnackbar({
            ...snackbar,
            open: true,
            message: "SubmissionID " + message + " copied to clipboard",
        });
    };

    const closeSnackbar = () => {
        setSnackbar({
            ...snackbar,
            message: "",
            open: false,
        });
    };

    useEffect(() => {
        if (snackbar.open === true) {
            setTimeout(() => {
                closeSnackbar();
            }, 1500);
        }
    }, [showSnackbar]);

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.abbreviation!, label: v.name! };
                });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        QueueService.getQueue({
            filter: filter ?? "all",
            state: stateId ?? "",
        }).then(
            (resp) => {
                setQueueList(resp.data || []);
            },
            (error) => {
                console.log(error);
                setError(error);
            }
        );
    }, [stateId]);

    const onStateChange = (
        value: OptionType | null,
        actionMeta: ActionMeta<OptionType>
    ) => {
        setStateId(value?.value ?? "");
    };

    const filterOption = (option: OptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    const rows = queuelist.map((v, i) => {
        const oldest = v.oldestFileDate ? v.oldestFileDate : "02/23/1996";
        const oldmom = moment.utc(oldest).local();
        const newest = moment(new Date(Date.now()));

        const time: number = newest.diff(oldmom, "minutes");

        if (time >= 60) {
            return (
                <QueueRow
                    attorneyQueue={v}
                    filter={filter ?? ""}
                    state={state ?? ""}
                    color="red"
                    snackBarMessage={showSnackbar}
                />
            );
        } else if (time >= 30) {
            return (
                <QueueRow
                    key={i}
                    attorneyQueue={v}
                    filter={filter ?? ""}
                    state={state ?? ""}
                    color="yellow"
                    snackBarMessage={showSnackbar}
                />
            );
        } else {
            return (
                <QueueRow
                    attorneyQueue={v}
                    filter={filter ?? ""}
                    state={state ?? ""}
                    snackBarMessage={showSnackbar}
                />
            );
        }
    }); // end of map

    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-body py-2 px-3 border-bottom border-light">
                        <div className="row">
                            <div className="col-sm-3">
                                <label
                                    htmlFor="selState"
                                    className="form-label"
                                >
                                    State
                                </label>
                                <Select
                                    id="selState"
                                    name="selState"
                                    value={stateOptions.filter(
                                        (c) => c.value === stateId
                                    )}
                                    filterOption={filterOption}
                                    options={stateOptions}
                                    onChange={onStateChange}
                                />
                            </div>
                        </div>
                    </div>
                    <Snackbar
                        anchorOrigin={{
                            vertical: snackbar.vertical,
                            horizontal: snackbar.horizontal,
                        }}
                        open={snackbar.open}
                        onClose={closeSnackbar}
                        message={snackbar.message}
                        key={snackbar.vertical + snackbar.horizontal}
                    />
                    <div className="card-body">
                        <table
                            className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                            cellSpacing={0}
                            id="tickets-table"
                        >
                            <thead className="bg-light">
                                <tr>
                                    <th className="fw-medium"></th>
                                    <th className="fw-medium">Attorney</th>
                                    <th className="fw-medium">Count</th>
                                    <th className="fw-medium">Emergency</th>
                                    <th className="fw-medium">Oldest File</th>
                                    <th className="fw-medium"></th>
                                </tr>
                            </thead>

                            <tbody className="font-14">{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
